import { cap } from '../../../State'
import { translations } from '../../../translations'
import { Icon } from './Icons'

const language = cap.language.state || 'IT'
const t = translations[language]

const ProgressRing = ({ pct }) => {
  const dasharray = `${(pct / 100) * 56.5} 56.5`
  return (
    <span className="gf-status__ring">
      <svg width="22" height="22">
        <circle cx="11" cy="11" r="9" fill="none" stroke="var(--surface-3)" strokeWidth="2.5" />
        <circle
          cx="11"
          cy="11"
          r="9"
          fill="none"
          stroke="var(--primary)"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeDasharray={dasharray}
        />
      </svg>
      <span className="gf-status__ring-pct">{pct}</span>
    </span>
  )
}

/**
 * Banner di stato Nora con avanzamento campi e filtro revisione
 * @param {Object} props
 * @param {number} props.filledFields - Campi compilati
 * @param {number} props.totalFields - Campi totali
 * @param {number} props.noraFilledCount - Campi precompilati da Nora
 * @param {number} props.errorCount - Campi con errori
 * @param {number} props.reviewCount - Sezioni da rivedere
 * @param {boolean} props.reviewOnly - Filtro solo revisione attivo
 * @param {Function} props.onToggleReviewOnly - Toggle filtro revisione
 * @param {string} [props.noraQuery] - Testo query Nora
 * @returns {JSX.Element} Banner di stato
 */
export const StatusBanner = ({
  filledFields,
  totalFields,
  noraFilledCount,
  errorCount,
  reviewCount,
  reviewOnly,
  onToggleReviewOnly,
  noraQuery
}) => {
  const showProgress = totalFields > 0
  const pct = showProgress ? Math.round((filledFields / totalFields) * 100) : 0
  const fieldLabel = errorCount === 1 ? t.gfCampo : t.gfCampi

  return (
    <div className="gf-status">
      {showProgress && (
        <div className="gf-status__pill">
          <ProgressRing pct={pct} />
          <span>
            {filledFields}/{totalFields} {t.gfCampi}
          </span>
        </div>
      )}
      <div className="gf-status__text-wrap">
        <span className="gf-nora-badge">
          <Icon name="sparkles" size={12} /> Nora
        </span>
        <span className="gf-status__text">
          {noraFilledCount > 0 ? (
            <>
              {t.gfHaPrecompilato}{' '}
              <strong>
                {noraFilledCount} {t.gfCampi}
              </strong>
              {noraQuery && (
                <>
                  {' '}
                  {t.gfDa} <i>"{noraQuery}"</i>
                </>
              )}
              {errorCount > 0 && (
                <>
                  {' · '}
                  <span className="gf-status__review">
                    {errorCount} {fieldLabel} {t.gfCampiDaRivedere}
                  </span>
                </>
              )}
            </>
          ) : errorCount > 0 ? (
            <span className="gf-status__review">
              {errorCount} {fieldLabel} {t.gfCampiObbligatoriDaCompilare}
            </span>
          ) : (
            <>{t.gfTuttiCampiObbligatoriCompilati}</>
          )}
        </span>
      </div>
      {reviewCount > 0 && (
        <div className="gf-status__actions">
          <button
            type="button"
            className="gf-toggle-chip"
            aria-pressed={reviewOnly}
            onClick={onToggleReviewOnly}
            title={reviewOnly ? t.gfMostraTutteSezioni : t.gfMostraSoloSezioniDaRivedere}
          >
            <Icon name={reviewOnly ? 'check' : 'eye'} size={12} />
            {reviewOnly
              ? `${t.gfFiltrato} (${reviewCount})`
              : `${t.gfSoloDaRivedere} (${reviewCount})`}
          </button>
        </div>
      )}
    </div>
  )
}
